export const faqData = [
  {
    question: 'btbxx平台适合什么类型的企业使用？',
    answer: 'btbxx平台面向各类规模的企业提供服务，无论您是初创公司、中小型企业还是大型集团，都能在btbxx找到适合的解决方案。我们的模块化设计允许企业根据自身需求灵活选择功能组合。',
  },
  {
    question: 'btbxx平台的部署周期是多长？',
    answer: 'btbxx平台标准版的部署周期通常为1-2周。对于有定制化需求的企业客户，部署周期会根据具体需求调整，一般在4-6周内完成。我们的实施团队会全程跟进，确保按时交付。',
  },
  {
    question: 'btbxx平台的数据安全如何保障？',
    answer: 'btbxx采用多重安全防护机制，包括数据传输加密（TLS 1.3）、存储加密（AES-256）、访问控制（RBAC）、操作审计、DDoS防护等。我们定期进行安全审计和渗透测试，确保客户数据的安全性。',
  },
  {
    question: 'btbxx平台是否支持与现有系统集成？',
    answer: '是的，btbxx平台提供标准化的API接口和丰富的预置集成方案，支持与企业现有的ERP、CRM、财务系统、OA系统等无缝对接。我们的技术团队也可以根据客户需求开发定制化集成方案。',
  },
  {
    question: 'btbxx的收费模式是怎样的？',
    answer: 'btbxx采用灵活的模块化定价策略，企业可以根据实际需求选择功能模块，按需付费。我们提供免费试用期，让您在充分体验后再做决策。具体价格方案请联系我们的销售团队获取。',
  },
  {
    question: 'btbxx平台提供售后技术支持吗？',
    answer: '当然！btbxx为客户提供全方位的售后技术支持服务。包括7x24小时在线客服、专属客户成功经理、定期系统健康检查、免费产品升级等。我们的客户满意度长期保持在95%以上。',
  },
];

export const testimonials = [
  {
    id: '1',
    name: '张明远',
    company: '远航科技集团',
    role: 'CEO',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20businessman%20portrait%2C%20clean%20studio%20background%2C%20warm%20cream%20tone%2C%20professional%20headshot%2C%20confident%20expression%2C%20modern%20corporate%20style&width=200&height=200&seq=btbxx-avatar-1&orientation=squarish',
    content: '使用btbxx平台后，我们的运营效率提升了200%。从数据分析到客户管理，btbxx的一站式服务让团队协作更加流畅，是我们数字化转型的最佳伙伴。',
    rating: 5,
  },
  {
    id: '2',
    name: '李婷',
    company: '星辰电商有限公司',
    role: '运营总监',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20businesswoman%20portrait%2C%20clean%20studio%20lighting%2C%20warm%20beige%20background%2C%20modern%20corporate%20headshot%2C%20professional%20elegant%20style&width=200&height=200&seq=btbxx-avatar-2&orientation=squarish',
    content: 'btbxx的智能营销工具帮我们在三个月内将获客成本降低了45%，同时销售额增长了80%。数据驱动的营销策略让每一分钱都花在刀刃上。',
    rating: 5,
  },
  {
    id: '3',
    name: '王建华',
    company: '建业制造集团',
    role: 'CTO',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20tech%20executive%20portrait%2C%20studio%20photography%2C%20warm%20neutral%20background%2C%20modern%20minimal%20headshot%2C%20confident%20professional%20look&width=200&height=200&seq=btbxx-avatar-3&orientation=squarish',
    content: '作为技术负责人，我最看重的是btbxx的技术架构和扩展性。云原生架构让系统稳定性有了质的飞跃，API集成能力也让我们的技术栈更加灵活。',
    rating: 5,
  },
  {
    id: '4',
    name: '陈思雨',
    company: '云端教育科技',
    role: '创始人',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20entrepreneur%20portrait%2C%20clean%20studio%20background%2C%20warm%20cream%20tone%2C%20modern%20business%20headshot%2C%20friendly%20professional%20style&width=200&height=200&seq=btbxx-avatar-4&orientation=squarish',
    content: '作为创业公司，btbxx的高性价比方案让我们以最小的成本获得了顶级企业才有的数字化能力。从零到一的搭建过程非常顺利，btbxx团队的专业支持让我们印象深刻。',
    rating: 5,
  },
];